/**
 * API voor het model-portal (fase 2, go Jordy 02-10-2026).
 *
 * Een EIGEN token onder een eigen sleutel: het admin-token (lib/api) wordt hier
 * nooit meegestuurd, en het model-token komt nooit in het dashboard terecht.
 * De server weigert beide over en weer (src/api/routes/model_portal.py).
 */
const SLEUTEL = 'novahub_portal_token'

export function portalToken(): string {
  try { return localStorage.getItem(SLEUTEL) || '' } catch { return '' }
}

export function zetPortalToken(token: string): void {
  try { localStorage.setItem(SLEUTEL, token) } catch { /* privé-venster */ }
}

export function wisPortalToken(): void {
  try { localStorage.removeItem(SLEUTEL) } catch { /* idem */ }
}

export class PortalFout extends Error {
  constructor(public status: number, message: string) { super(message) }
}

export async function portalVraag<T>(pad: string, opties: RequestInit = {}): Promise<T> {
  const kop: Record<string, string> = { 'Content-Type': 'application/json' }
  const token = portalToken()
  if (token) kop.Authorization = `Bearer ${token}`
  const res = await fetch(pad, { ...opties, headers: { ...kop, ...(opties.headers as Record<string, string> | undefined) } })
  if (res.status === 401 && token) wisPortalToken()
  if (!res.ok) {
    const body = await res.json().catch(() => null)
    throw new PortalFout(res.status, String(body?.detail || `HTTP ${res.status}`))
  }
  return res.json() as Promise<T>
}

/** CSV ophalen met het token in de kop (niet in de URL) en als bestand bewaren. */
export async function downloadExport(van: string, tot: string): Promise<void> {
  const res = await fetch(`/api/model/transactions/export?from_date=${van}&to_date=${tot}`, {
    headers: { Authorization: `Bearer ${portalToken()}` },
  })
  if (!res.ok) throw new PortalFout(res.status, `HTTP ${res.status}`)
  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `sales_${van}_${tot}.csv`
  a.click()
  URL.revokeObjectURL(url)
}
